module.exports = __webpack_public_path__ + "static/media/gcl-logo.709227e9.png";